import * as Types from "./../constants/Typesaction";

let Initstate = {
    user: '',
    isLogined: false

};

const reducer = (state = Initstate, action) =>
{
    switch (action.type) {

        case Types.LOGIN:

            let user = ''
            let result = action.result;
            if (result.code === 200) {
                user = setUser(result.data);
                state = { ...state, user: user, isLogined: true }
                return { ...state }
            }
            else {
                user = result;
                state = { ...state, user: user, isLogined: false }
                return { ...state }
            }

        case Types.LOGOUT:

            localStorage.removeItem("user");
            state = { ...state, user: "", isLogined: false }
            return { ...state }
        // console.log(state);
        default:
            return { ...state }


    }
};
export default reducer;

const getUser = () =>
{
    let user = localStorage.getItem("user");
    if (user) {
        user = JSON.parse(user);
        if (user.MaNV) {
            return { "code": 200, "user": user };
        }
        else {
            return { "code": 201 }
        }
    } else {
        return { "code": 201 }
    }
}
const setUser = (user) =>
{

    localStorage.setItem("user", JSON.stringify(user));
    return { "code": 200, "user": user };
}
